import styled from 'styled-components';

import Main from '../Main';

export default styled(Main)`
	flex-direction: column;

	& > .customScrollbar {
		padding: 0 var(--template-padding-sides);
		min-height: 100%;
		& > * {
			flex: 1;
		}
	}

	&.flex {
		& > .customScrollbar {
			display: flex;
			flex-direction: column;
		}
	}
`;
